import { useEffect, useState } from "react";
import { Card, Form, Button, Col, Row } from "react-bootstrap";
import { initializeSetOption } from "../../../../utils/InitializeSetDefault";
import { addEditServiceRequest, getServiceRequest } from "../../../../commons/ServiceRequest";
import { useAlert } from "../../../../context/AlertContext";
import InputSearch from "../../../../components/InputSearhComponent";
import { getQueryString } from "../../../../utils/Query";
import TableForm2s from "../../../../components/TableFormScrb";
import { formatDate } from "../../../../commons/FormatValue";
import { useLocation, useNavigate } from "react-router-dom";
import ServiceRequestService from "../../../../services/servicerequest.service";
import ButtonOptionSubmenu from "../../../../components/ButtonOptionSubmenu";
import ConfirmModal from "../../../../components/ConfirmModal";
import ImageViewing from "./imageViewPrint";
import TechSvrNoFileService from "../../../../services/techsvrnofile.service";
import TechWorkClosedService from "../../../../services/techworkclose.service";
import FileUploadsService from "../../../../services/fileupload.service";

export default function AddRep() {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [JobType, setJobType] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allCountData, setAllCountData] = useState();
  const [WorkNo, setWorkNo] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [dataModal, setDataModal] = useState();
  const { state } = useLocation()
  const [showImageViewing, setShowImageViewing] = useState(false);

  useEffect(() => {
    setJobType(state.JobType)
  }, []);

  const columns = [
    {
      name: "Seq_No",
      label: "เลขที่ใบสั่งงาน",
      width: "180px",
      readOnly: true
    },
    {
      name: "Cus_Code",
      label: "รหัสลูกค้า/สาขา",
      width: "180px",
      readOnly: true
    },
    {
      name: "Cus_No",
      label: "เลขที่สาขา",
      width: "180px",
      readOnly: true
    },
    {
      name: "Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      width: "250px",
      readOnly: true
    },
    {
      name: "Detail",
      label: "รายละเอียดสินค้า",
      readOnly: true,
      width: "250px",
    },
    {
      name: "Equip_No",
      label: "หมายเลขเครื่อง",
      width: "180px",
      readOnly: true
    },
    {
      name: "Tech_work_doc",
      label: "เลขที่ปฏิบัติงาน",
      readOnly: true
    },
    {
      name: "Service_rep_no",
      label: "หมายเลขบริการ",
    },
    {
      name: "file",
      label: "เพิ่มรูป",
      type: "addImage"
    },
    {
      name: "",
      label: "รูปภาพ",
      type: "viewImage"
    },
  ];

  const searchInput = [
    {
      name: "sup_team",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      // value: defaultData?.tech_name,
      disabled: true,
      size: 4
    },
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      // value: defaultData?.team,
      disabled: true,
      size: 4
    },
    {
      name: "job_type_id",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      size: 4,
      noneAsync: true,
      filterBy: ["Job_Type_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Job_Type_Name",
        dataset: JobType
      })
    },
    {
      name: "start",
      label: "วันที่ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "date",
      size: 4,
      max: "updatedAt"
    },
    {
      name: "end",
      label: "ถึงวันที่",
      classNames: { label: "mb-3" },
      type: "date",
      size: 4,
      min: "createdAt"
    },
    {
      name: "seq_no",
      label: "เลขที่ใบสั่งาน",
      classNames: { label: "mb-3" },
      size: 4,
      filterBy: ["seq_no"],
      options: initializeSetOption({
        key: "seq_no",
        label: "seq_no",
        dataset: WorkNo
      }),
      queryService: (query, value) => {
        const q = getQueryString({ seq_no: value, limit: 100, page: 1 })
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: TechWorkClosedService.getSeqNo(q),
          callback: (array) => {
            const newArray = array.data?.map(arr => ({
              seq_no: arr.seqJob.seqNo
            }))
            setWorkNo(newArray)
          }
        });
      }
    },
  ];

  const getDataTable = (search) => {
    const page = search?.page || currentPage
    const limit = search?.limit || rowsPerPage
    const q = getQueryString({ page: page, limit: limit, ...search })
    setCurrentPage(page)
    setRowsPerPage(limit)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechWorkClosedService.getJob(q),
      callback: (res) => { initData(res.data); setAllCountData(res.allCount) }
    });
  }
  function initData(data) {
    const newArray = data[0]?.ServiceRequestDt?.map((items) => ({
      ...data[0],
      Seq_No: data[0].TechnicianPlan.seq_no,
      Cus_Code: data[0].TechnicianPlan?.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_Code
      ,
      Cus_Name: data[0].TechnicianPlan?.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_Name
      ,
      Cus_No: data[0].TechnicianPlan?.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_NumBranch
      ,
      Job_Cus_Date: formatDate(data[0].TechnicianPlan?.SeqInstalljob?.InformInstallJobs?.Job_Cus_Date),
      Depart_St_Name: data[0].TechnicianPlan?.DepartJob?.Depart_St_Name,
      Seq_St_Name: data[0].SequneceStatus?.Seq_St_Name,
      file: data[0].TechnicianPlan.TechWorkClosed?.TechSvrNoFiles?.slice(-1) || [],
      Detail: items.BillOfReqDt.Item.Item_Name_TH || items.BillOfReqDt.Item.Item_Name_EN,
      // Equip_No: prod_set_mc.mc_no,
      Tech_work_doc: data[0].TechnicianPlan.TechWorkJob?.tech_work_doc,
      Service_rep_no: data[0].TechnicianPlan.TechWorkClosed?.service_rep_no,
    }));
    setTableData(newArray || [])
  }

  const destination = "service_rep"
  async function handleSubmit(e, { dataCallback, showCallback }) {
    e.preventDefault();
    const All = []

    await Promise.all(
      dataCallback.map(async ele => {

        // console.log(dataCallback[i], body)
        const newFile = ele.file?.filter(e => !e.id)

        if (newFile?.length) {
          const { files } = await FileUploadsService.createFileUploads(destination, [newFile[newFile?.length - 1]])
          // console.log(newFile)
          await TechSvrNoFileService.createTechSvrNoFile(
            {
              "array": [{
                "tech_work_close_id": ele.TechnicianPlan.TechWorkClosed.id,
                "file_path": files[0],
                "file_type": "Image"
              }]
            }
          )
        }

        addEditServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: TechWorkClosedService.createTechWorkClose(
            {
              "tech_plan_id": ele.tech_plan_id,
              service_rep_no: ele.Service_rep_no,
              "tech_work_close_date": ele.TechnicianPlan?.TechWorkClosed.tech_work_close_date,
              "seq_status_id": ele.TechnicianPlan?.TechWorkClosed.seq_status_id,
              "cus_accepted": ele.TechnicianPlan?.TechWorkClosed.cus_accepted,
              "cus_signed_date": ele.TechnicianPlan?.TechWorkClosed.cus_signed_date,
            }
          ),
          callback: res => { },
        });
      })
    )

    setShowModal(false)
  }

  function fetchSeqNo(search) {
    return
    if (!search) {
      if (!allSeqNo) {
        getSeqNoList({}, 'all')
      } else {
        setSeqNo(allSeqNo)
      }
      return
    }

    getSeqNoList(search)
  }
  function getSeqNoList(search, isAll) {
    const q = getQueryString(search)
    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: TechWorkClosedService.getSeqNo(q),
      callback: (res) => {
        const data = res.data.map(d => {
          return {
            seq_no: d.seq_no,
            tech_plan_id: d.id
          }
        })
        console.log(data)
        if (isAll) {
          setAllSeqNo(data)
        }
        setSeqNo(data)
      }
    });
  }
  return (
    !showImageViewing
      ? <>
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-center align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">
              เพิ่มหมายเลขใบงานบริการ
            </Card.Title>
          </Card.Header>

          <Card.Body>
            <InputSearch
              inputField={searchInput}
              field={searchInput}
              searchCallback={search => search ? getDataTable(search) : setTableData([])}
              searchByField={{ name: 'seq_no', queryService: search => fetchSeqNo(search) }}
              fieldClassName={{ actionButton: "", inputRow: "justify-content-center" }}
            />
          </Card.Body>
        </Card>

        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">

            </Card.Title>

          </Card.Header>

          <Form noValidate>
            <Card.Body>
              <TableForm2s
                data={tableData}
                columns={columns}
                pending={loading}
                searchFilter={tableData}
                pagination={false}
                isEditIndex
                onChangeCallback={newData => {
                  const service_rep_no = newData.find((e, i) => i == e.isEdit)?.Service_rep_no
                  const newDatas = newData.map(el => (
                    { ...el, Service_rep_no: service_rep_no, isEdit: true }
                  ))
                  setTableData(newDatas)
                  // setDataModal()
                }}
                callbackImage={setShowImageViewing}
              />
            </Card.Body>
          </Form>
          <Card.Body>
            <Row className="justify-content-end mt-3">
              <Col className="col-auto">
                <Button
                  type="submit"
                  variant="success"
                  className="me-2 px-5 py-2 text-dark rounded-pill"
                  onClick={() => setShowModal(!showModal)}
                  disabled={!tableData?.length}
                >
                  บันทึกข้อมูล
                </Button>
                <ConfirmModal
                  show={showModal}
                  data={tableData}
                  content={"save"}
                  onSubmitCallback={handleSubmit}
                />
                <Button
                  variant="outline-secondary"
                  className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                  onClick={() =>
                    navigate("/service_work/perform/report")
                  }
                >
                  ย้อนกลับ
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </>
      : (
        <ImageViewing
          arrayImage={showImageViewing}
          onClickBack={() => {
            setShowImageViewing(false);
            // setWebsiteName("ปิดงาน")
          }}
          destination={destination}
        />
      )
  );
}